import React from 'react'
import AboutHero from '../components/AboutHero/AboutHero'
import VisionSection from '../components/VisionSection/VisionSection'
import DifferenceSection from '../components/DifferenceSection/DifferenceSection'
import WhyChoose from '../components/WhyChoose/WhyChoose'
import BookingSection from '../components/BookingSection/BookingSection'
import SunglassesCollectionSection from '../components/SunglassesCollectionSection/SunglassesCollectionSection'
import Footer from '../components/Footer/Footer'
import { Helmet } from 'react-helmet'
const SpecificService = ({ collections, aboutHeroContent, VisionSectionContent, cardContent, whyChooseContent , heading, cardContentHeading, whyChooseContentHeading, pageText = ""}) => {
    return (
        <>
        <Helmet>
        <title>Elite Optix Services | Comprehensive Eye Care & Designer Eyewear</title>
        <meta
            name="description"
            content="Discover Elite Optix's comprehensive eye care services, advanced lens technology, and curated designer eyewear collections. Book your appointment today!"
        ></meta>
        <link
            rel="canonical"
            href="https://eliteoptix.com/services"
        />
        </Helmet>
            <AboutHero page="services" img={aboutHeroContent.img}
                title={aboutHeroContent.title}
                subtitle={aboutHeroContent.subtitle}
                pageText={pageText}
            />
            <VisionSection page="specific-service"
                title={VisionSectionContent.title}
                subtext={VisionSectionContent.subtext}
                listordesc={VisionSectionContent.listordesc}
                subtexttwo={VisionSectionContent.subtexttwo || ""}
                subtextthree={VisionSectionContent.subtextthree || ""}
                buttontext='Discover Our Story'
                img={VisionSectionContent.img}
            />
            <DifferenceSection  cardContent={cardContent} cardContentHeading={cardContentHeading} />
            <div className='bg_gradient'>
                <SunglassesCollectionSection collections={collections} heading={heading}  />
                <WhyChoose whyChooseContent={whyChooseContent} whyChooseContentHeading={whyChooseContentHeading} />
                <BookingSection />
            </div>
            <Footer />
        </>
    )
}

export default SpecificService